import { createFileRoute } from '@tanstack/react-router'
import { AnexBroadbandSignUp } from '@anex/common'
import '@anex/common/dist/index.css'

export const Route = createFileRoute('/sign-up')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div id="signup" className="content-container py-5">
      <AnexBroadbandSignUp
        anexApiBaseUrl={window['ANEX_API_ENDPOINT']}
        anexApiToken={window['ANEX_API_TOKEN']}
        wholesalerCode="LPE"
        wholesalerName="LPE Broadband"
        allowOpticommSale={false}
        allowVoipSale={false}
        supportContact={SUPPORTPHONE}
        keyFactSheetUrl={{
          nbn: '/pdf/nbn-key-facts-sheet.pdf',
        }}
        privacyPolicyUrl="https://localityenergy.com.au/privacy-policy/"
        excludeProviders={['Uniti', 'Telstra']}
      />
    </div>
  )
}
